"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPTChooser = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const react_1 = __importDefault(require("react"));
const DataChooser_1 = __importDefault(require("../DataChooser"));
const makeDataChooser_1 = __importDefault(require("../helpers/makeDataChooser"));
exports.SPTChooser = (0, makeDataChooser_1.default)((props) => {
    return (react_1.default.createElement(DataChooser_1.default, Object.assign({}, props, { filters: Object.assign(Object.assign({}, props.filters), { enabled: ['TRUE'] }), selectLabel: lib_i18n_1.default.t('select-spt'), type: [DataType_1.default.STAFF, DataType_1.default.TEAM, DataType_1.default.POSITION], showTotals: true })));
});
exports.default = exports.SPTChooser;
